import { Modal, ModalProps } from '../../components/Modal/Modal'
import React from 'react'
import { Button } from '../../components/Button/Button'
import { Link } from 'react-router-dom'

export const NoQuotaModalHeader = (
  <h3 className='text-center w-100'>
    <i className='bi bi-lock' /> Analytics Hub
  </h3>
)

export const NoQuotaModalBody = (
  <div className='text-center'>
    The Analytics Hub provides deep insights into your full client servicing motion based on data in Zocks and in connected systems.
    <p className='mt-2 mb-0'>Analytics Hub is available in our Professional plan.</p>
  </div>
)

export const NoQuotaModalFooter = (
  <Button variant={'primary'}>
    <Link to='/account/plan' className='zocks-text-white'>
      Upgrade
    </Link>
  </Button>
)

export const NoQuotaModal: React.FC<ModalProps> = ({ header, body, footer }) => {
  return (
    <Modal
      className='scoped-block-modal'
      show={true}
      header={header ?? NoQuotaModalHeader}
      body={body ?? NoQuotaModalBody}
      footer={footer ?? NoQuotaModalFooter}
      centered={true}
    />
  )
}
